import { jsx as _jsx } from "react/jsx-runtime";

const LoadingValue = () => /*#__PURE__*/_jsx("span", {
  className: "loading",
  "data-selenium-test": "formatted-property-value-loading-value",
  children: "..."
});

export default LoadingValue;